import React from 'react'
import PropTypes from 'prop-types'
import './header-search-editable.scss'
import { pushHeaderSearchEditable } from "../../../../helpers/gtm";


const HeaderSearchEditable = ({ keyword, editLabel, onClick }) => (
  <div className="header-search-editable">
    <div className="header-search-editable__keyword">
      {keyword}
    </div>
    <div
      role="button"
      tabIndex="0"
      className="header-search-editable__edit"
      onKeyDown={() => {}}
      onClick={(event) => { pushHeaderSearchEditable(); onClick(event) }}
    >
      {editLabel}
    </div>
  </div>
)

HeaderSearchEditable.propTypes = {
  onClick: PropTypes.func.isRequired,
  keyword: PropTypes.string.isRequired,
  editLabel: PropTypes.string.isRequired,
}

export default HeaderSearchEditable
